var _a;
import GallerySettingsModal from './components/GallerySettingsModal';
var Modals = {
    GALLERY_SETTINGS: 'gallery-settings',
};
var ModalsMap = (_a = {},
    _a[Modals.GALLERY_SETTINGS] = GallerySettingsModal,
    _a);
export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map